<template>
  <div class="user-permissions" v-if="permitted">
    <slot />
  </div>
</template>

<script>
/**
 * Component to hide or show content based on user permissions.
 * This allows UI to be customised to current user.
 */
export default {
  name: 'Permissions',

  props: {
    permissions: {
      type: Object,
      required: true,
      default() {
        return {}
      }
    },

    requireAll: {
      type: Object,
      default() {
        return {}
      }
    },

    requireOne: {
      type: Object,
      default() {
        return {}
      }
    }
  },

  computed: {
    hasOnePermission() {
      const required = this.requireOne
      const permissions = this.permissions

      if (!Object.keys(required).length) return true
      if (!Object.keys(permissions).length) return false

      return Object.keys(required)
        .map((relm) => {
          const actions = required[relm]

          return actions
            .map((action) => {
              return !!permissions[relm].includes(action)
            })
            .includes(true)
        })
        .includes(true)
    },

    hasAllPermissions() {
      const required = this.requireAll
      const permissions = this.permissions

      if (!Object.keys(required).length) return true
      if (!Object.keys(permissions).length) return false

      return !Object.keys(required)
        .map((relm) => {
          const actions = required[relm]

          return !actions
            .map((action) => {
              return !!permissions[relm].includes(action)
            })
            .includes(false)
        })
        .includes(false)
    },

    permitted() {
      return this.hasOnePermission && this.hasAllPermissions
    }
  }
}
</script>

<style lang="sass">
.permissions

</style>
